<template>
  <div>
    <div class="subheading">
      {{ $t('menuPreviewAllScreensPageHeader') }}
    </div>
    <v-layout
      align-center
      class="mt-2 mb-3"
    >
      <!-- Pick Preview Size -->
      <v-btn-toggle
        v-model="sizeButtonIndex"
        class="mr-4"
      >
        <v-btn
          small
          @click="previewSizeModifier = 3"
        >
          {{ $t('small') }}
        </v-btn>
        <v-btn
          flat
          small
          @click="previewSizeModifier = 5"
        >
          {{ $t('medium') }}
        </v-btn>
        <v-btn
          small
          @click="previewSizeModifier = 7"
        >
          {{ $t('large') }}
        </v-btn>
      </v-btn-toggle>
      <!-- Toggle Details -->
      <v-switch
        v-model="showStoreDecoderDetails"
        color="msr"
        :label="$t('menuPreviewAllScreensToggleDetails')"
      />
      <!-- Refresh -->
      <v-btn
        round
        flat
        class="ml-auto"
        @click="fetchData()"
      >
        <v-icon left>
          refresh
        </v-icon>
        {{ $t('refresh') }}
      </v-btn>
    </v-layout>
    <v-layout
      wrap
      align-end
    >
      <div
        v-for="(tvdecoderId, tvdecoderIndex) in Object.keys(
          tvdecoderIdToPreviewData
        )"
        :key="tvdecoderId + '-' + tvdecoderIndex"
      >
        <v-layout
          v-if="showStoreDecoderDetails"
          class="subheading mb-2"
          wrap
          :style="{'max-width': previewMaxWidth + 'px'}"
        >
          <router-link
            :title="$t('menuTVDecoderStoreMenuLink')"
            :to="{
              name: 'storemenu',
              params: {
                storeId:
                  tvdecoderIdToPreviewData[tvdecoderId].tvdecoder.store.id,
              },
            }"
            style="display: inline-block; font-size: smaller; line-height: 1"
          >
            <v-icon
              small
              class="mr-1"
            >
              location_on
            </v-icon>
            {{ tvdecoderIdToPreviewData[tvdecoderId].tvdecoder.store.city }},
            {{ tvdecoderIdToPreviewData[tvdecoderId].tvdecoder.store.name }}:
          </router-link>
          &nbsp;
          <router-link
            :to="{
              name: 'decoder',
              params: {ctype: 'tv', decoderId: tvdecoderId},
            }"
            style="display: inline-block; font-size: smaller; line-height: 1"
          >
            <v-icon
              small
              class="mr-1"
            >
              tv
            </v-icon>
            {{ tvdecoderIdToPreviewData[tvdecoderId].tvdecoder.description }}
          </router-link>
        </v-layout>
        <v-layout
          wrap
          align-center
        >
          <tv-decoder-menu-page-preview
            v-for="(menuPage, menuPageIndex) in tvdecoderIdToPreviewData[
              tvdecoderId
            ].current_menu.menu_pages"
            :key="menuPageIndex"
            :title="$t('menuTVDecoderStoreMenuLink')"
            :tvdecoder="tvdecoderIdToPreviewData[tvdecoderId].tvdecoder"
            :menu-page="menuPage"
            class="unselectable mr-3 mb-3"
            :preview-max-width="previewMaxWidth"
            :preview-max-height="previewMaxHeight"
          />
        </v-layout>
      </div>
    </v-layout>
  </div>
</template>

<script>
import TvDecoderMenuPagePreview from '@/components/DecoderDetail/TvDecoderMenuPagePreview';

export default {
  components: {
    TvDecoderMenuPagePreview,
  },
  data() {
    return {
      tvdecoderIdToPreviewData: {},
      showStoreDecoderDetails: false,
      sizeButtonIndex: 1,
      previewSizeModifier: 5,
    };
  },
  computed: {
    menuId() {
      return this.$route.params.menuId;
    },
    previewMaxWidth() {
      return 96 * this.previewSizeModifier;
    },
    previewMaxHeight() {
      return 54 * this.previewSizeModifier;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      return this.$api
        .getMenuPreviewForAllScreens(this.menuId)
        .then((response) => {
          this.tvdecoderIdToPreviewData = response.data;
        });
    },
    populateHighlightPreviewIframeWithOverlayData(
      menuItemHighlightPayload,
      widgetIndex
    ) {
      const previewWidgets = this.$refs['highlight-previews'];
      const previewWidget = previewWidgets[widgetIndex];
      if (!previewWidget) {
        return;
      }
      const overlayData = {
        menu_item_highlight: menuItemHighlightPayload,
      };
      previewWidget.updateOverlayData(overlayData);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MenuPreviewAllScreens.vue